var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconFamily18 = function SvgAIconFamily18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    "aria-hidden": true
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 9,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4,
    r: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 14,
    r: 1.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 14,
    r: 1.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 1.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 1.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 1.5
  })));
};
export { SvgAIconFamily18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJjdXJyZW50Q29sb3IiPgo8Y2lyY2xlIGN4PSI0IiBjeT0iNCIgcj0iMS41IiAvPgo8Y2lyY2xlIGN4PSI0IiBjeT0iOSIgcj0iMS41IiAvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iNCIgcj0iMS41IiAvPgo8Y2lyY2xlIGN4PSI5IiBjeT0iOSIgcj0iMS41IiAvPgo8Y2lyY2xlIGN4PSI0IiBjeT0iMTQiIHI9IjEuNSIgLz4KPGNpcmNsZSBjeD0iOSIgY3k9IjE0IiByPSIxLjUiIC8+CjxjaXJjbGUgY3g9IjE0IiBjeT0iNCIgcj0iMS41IiAvPgo8Y2lyY2xlIGN4PSIxNCIgY3k9IjkiIHI9IjEuNSIgLz4KPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMS41IiAvPgo8L3N2Zz4=";